import { Flex, Text } from "@mantine/core";
import { Loading } from "components";
import { ReportParamsType } from "constants/types/common";
import { FC, useMemo } from "react";
import { formatCurrency } from "utils/helpers/format";
import { usePurchaseReport } from "utils/hooks/request/useReport";
import PurchaseReportTable from "./components/PurchaseReportTable/PurchaseReportTable";

interface PurchaseReportTabProps {
  params: ReportParamsType;
}

const PurchaseReportTab: FC<PurchaseReportTabProps> = ({ params }) => {
  // Bộ lọc dùng chung cho cả 3 tab nên params có thể còn `status` của đơn BÁN
  // do người dùng chọn ở tab khác. Endpoint mua hàng validate enum đơn MUA
  // (draft | completed) nên phải bỏ đi, không thì đổi tab là dính 400.
  const { status: _saleStatus, ...purchaseParams } = params;
  const { purchaseReport, isLoading } = usePurchaseReport(purchaseParams);
  const rows = useMemo(() => purchaseReport ?? [], [purchaseReport]);

  // Khớp với dòng "Tổng cộng" ở cuối file Excel để hai bên luôn cùng một số
  const total = useMemo(
    () => rows.reduce((sum, r) => sum + r.totalAmount, 0),
    [rows],
  );

  return (
    <Loading variant="overlay" visible={isLoading}>
      <PurchaseReportTable data={rows} />
      <Flex justify="flex-end" align="center" gap={8} mt="sm" px={4}>
        <Text size="sm" c="dimmed">
          Tổng cộng:
        </Text>
        <Text fw={700} size="sm">
          {formatCurrency(total)}
        </Text>
      </Flex>
    </Loading>
  );
};

export default PurchaseReportTab;
